<div id="loading"></div>
<form id="myForm" method="post" [action]="url" target="_blank">
  <input type="hidden" name="request" [value]="data.request" />
  <input type="hidden" name="companyId" [value]="data.companyId" />
  <input type="hidden" name="country" [value]="data.country" />
</form>
